import { render, staticRenderFns } from "./ItemChipCustom.vue?vue&type=template&id=7bd57d98&scoped=true"
import script from "./ItemChipCustom.vue?vue&type=script&lang=ts"
export * from "./ItemChipCustom.vue?vue&type=script&lang=ts"
import style0 from "./ItemChipCustom.vue?vue&type=style&index=0&id=7bd57d98&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd57d98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd57d98')) {
      api.createRecord('7bd57d98', component.options)
    } else {
      api.reload('7bd57d98', component.options)
    }
    module.hot.accept("./ItemChipCustom.vue?vue&type=template&id=7bd57d98&scoped=true", function () {
      api.rerender('7bd57d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ItemChipCustom.vue"
export default component.exports